import { RootContainer } from '../../../../core/root_container';
import { SearchResultEnqueteAction } from '../../../actions/search_result_enquete/search_result_enquete_action';
import { SearchResultEnqueteJsEnv } from '../../../models/search_result_enquete/search_result_enquete_js_env';

import { FindProductOpinionFormBox } from '../../../../../../trylion-template/dist_components/esm/index';
import ReactDOM from 'react-dom';
import {Env} from "../../../env";
import {isSoloare} from "../../../models/js_env";

export class SearchResultEnqueteContainer extends RootContainer<SearchResultEnqueteJsEnv> {
  constructor() {
    super();

    ReactDOM.render(
      <FindProductOpinionFormBox
        mb={40}
        reviewYesOnClick={e => SearchResultEnqueteAction.setEnqueteAnswer(true)}
        reviewNoOnClick={e => SearchResultEnqueteAction.setEnqueteAnswer(false)}
        submitOpinionBtnOnClick={(e, textarea) => SearchResultEnqueteAction.sendSearchResultEnquete(textarea)}
        inquiryHref={this.getEachSiteUrl()}
      />,
      this.getElement('search_result_enquete')
    );
  }

  private getEachSiteUrl(): string {
    const siteType = Env.SITE_TYPE;
    if (isSoloare(siteType)) {
      return '/buyer/view/a310/DAS01010.html?reqCd=006';
    }
    return '/iqr/inquiryInputView/?inquiryId=IQR0007';
  }
}
